module.exports = __webpack_public_path__ + "img/confirm-hen.84fdd4ef.png";